import { buildConfigMap } from './pedigree-tool/pedigree/configLookup';

// What the pedigree-configuration read means for chart state, as a pure
// mapping from the response to the complete set of values it owns.
//
// THE BUG THIS EXISTS FOR (TGCLOUD-1804). In PedigreeBox this was a series of
// conditional setters — `if (res.data.configuration)`, then `if (pedigreeConfig)`,
// `if (customPositions)`, `if (loadedOrder)` — with no else on any of them. A
// family whose read came back `configuration: null`, or errored, therefore kept
// the PREVIOUS family's graph, pinned positions and established order and drew
// itself with them. `configuration: null` is not an edge case: an import that
// skipped its config save produces exactly that.
//
// Returning the WHOLE state, always, is the fix. A mapper that must name every
// field on every path cannot silently leave one behind, which a chain of `if`s
// can and did. Callers apply the result wholesale.
//
// Note what is NOT here: this deliberately owns only what the configuration
// read owns. The member list comes from /pedigree/details and is applied
// separately.
export const EMPTY_PEDIGREE_CONFIGURATION = Object.freeze({
  pedigreeConfig: null,
  position: null, // callers substitute a fresh Map — see pedigreeConfigurationFrom
  establishedOrder: null,
  orderLocked: false,
  isMigrated: false,
  initialDateModified: null
});

/**
 * @param {object|null|undefined} configuration - `res.data.configuration`, or
 *   null/undefined for "this family has no stored configuration", which is
 *   also the right answer for a failed read.
 * @returns {{
 *   pedigreeConfig: Map|null,
 *   position: Map,
 *   establishedOrder: Map,
 *   orderLocked: boolean,
 *   isMigrated: boolean,
 *   initialDateModified: {created: *, updated: *}|null
 * }}
 */
export function pedigreeConfigurationFrom(configuration) {
  if (!configuration) {
    return {
      pedigreeConfig: null,
      position: new Map(),
      establishedOrder: new Map(),
      orderLocked: false,
      isMigrated: false,
      initialDateModified: null
    };
  }

  const {
    pedigreeConfig,
    customPositions,
    establishedOrder,
    orderLocked,
    migrated,
    createdAt,
    updatedAt
  } = configuration;

  return {
    // Index every node under all the ids it carries (uid/_id/pid) so the
    // renderer resolves it whether the family is born-stable (node.uid ===
    // member._id) or legacy (node.uid is a UUID === member.uid).
    pedigreeConfig: pedigreeConfig ? buildConfigMap(pedigreeConfig) : null,
    position: customPositions
      ? new Map(Object.entries(customPositions))
      : new Map(),
    // values are ranks (numbers); keys are uids
    establishedOrder: establishedOrder
      ? new Map(Object.entries(establishedOrder))
      : new Map(),
    orderLocked: !!orderLocked,
    isMigrated: !!migrated,
    initialDateModified: { created: createdAt, updated: updatedAt }
  };
}
